<div class="container">
  <pdq-heading element="h6">Metrics</pdq-heading>
  <p class="description body-13-regular">
    Toggle on/off which metrics to pull from Triple Whale. Only enabled metrics will be synced.
  </p>
  <div class="metrics-list">
    @for (metric of metrics; track metric.id) {
      <div class="metric-row">
        <div class="metric-label">
          <p class="body-14-medium">{{ metric.label }}</p>
          <p class="metric-description body-12-regular">{{ metric.description }}</p>
        </div>
        <pdq-slide-toggle
          [disabled]="!integration?.isConnected"
          [defaultValue]="metric.enabled"
          (onToggle)="handleToggle(metric.id, $event)"></pdq-slide-toggle>
      </div>
    }
  </div>
</div>
